import {computed,ref,watch} from 'vue'
import {useStore} from 'vuex'
import deBounce from '../../foundation/js/deBounce'

const searchNow = deBounce((store,searchString)=>{
    if(searchString.length > 2){
        store.dispatch('productSearch/performStringSearch',{
            searchString: searchString
        })
        return false
    }
    store.commit('productSearch/set_products',[])
},500)

export default {
    name: 'SearchHeaer',
    setup() {
        const store = useStore()
        const searchString = ref(store.state.productSearch.search_string)

        const clearSearch = function(){
            store.commit('productSearch/set_search_string','')
            store.commit('productSearch/set_products',[])
            store.commit('productSearch/set_displayed_count', { displayedCount: 0 })
            store.commit('productSearch/set_search_result_max_count',0)
            searchString.value = ''
        }

        const getLabel = (labelRequested) => {
            return store.getters['labels/getLabel'](labelRequested)
        }
        
        watch(searchString,(newString)=>{
            searchNow(store,newString)
        })

        return {
            searchString,
            getLabel,
            clearSearch,
        }
    },
}